<template>
    <div>
        <modal :allow-cancel="false" class="text-center">
            <div v-if="totalRating < 13">
                <h2 v-text="$t('RATED_ARRANGEMENT_MODAL_THANK_YOU')"></h2>
                <p v-text="$t('RATED_ARRANGEMENT_MODAL_I_WILL')"></p>
                <p v-text="$t('RATED_ARRANGEMENT_MODAL_ALL_THE_BEST')"></p>
                <p>Freddie</p>
            </div>
            <div v-else class="mx-auto w-full md:w-3/5">
                <h2 v-text="$t('RATED_ARRANGEMENT_MODAL_FEEDBACK')"></h2>
                <p v-text="$t('RATED_ARRANGEMENT_MODAL_DELIGHTED')"></p>
                <p v-text="$t('RATED_ARRANGEMENT_MODAL_SEEING')"></p>
            </div>

            <template slot="actions-prefix">
                <button
                    v-if="totalRating < 13"
                    @click="closeModal()"
                    class="btn btn--primary"
                    v-text="$t('RATED_ARRANGEMENT_MODAL_YOU_ARE_WELCOME')"></button>
                <div v-else>
                    <button
                        v-if="false === hasAdditionalArrangementsToRate"
                        @click="redirectToRecommendAFriend"
                        class="btn btn--primary"
                        v-text="$t('RATED_ARRANGEMENT_MODAL_SEND_FREE_FLOWERS')"></button>
                    <button
                        v-if="hasAdditionalArrangementsToRate"
                        @click="closeModal"
                        class="btn btn--primary" v-text="$t('RATED_ARRANGEMENT_MODAL_RATE')"></button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/structure/Modal';

export default {
    name: 'RatedArrangementModal',
    props: {
        totalRating: {
            type: Number,
        },
    },
    methods: {
        /**
         * Close the modal instance.
         *
         * @returns {void}
         */
        closeModal() {
            this.$store.dispatch('cms/fetchRateableArrangements', true);

            this.$emit('closed');
        },

        /**
         * Redirect to free flowers and close modal.
         *
         * @returns {void}
         */
        redirectToRecommendAFriend() {
            this.$router.push({ name: 'account.free-flowers' });
            this.closeModal();
        },
    },
    computed: {
        ...mapGetters({
            rateableArrangements: 'cms/getRateableArrangements',
        }),
        hasAdditionalArrangementsToRate() {
            return (this.rateableArrangements || []).length > 1;
        },
    },
    components: {
        Modal,
    },
};
</script>
